export { makeCacheMapKit } from './src/cachemap.js';
